var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"my-3"},[_c('b-col',{staticClass:"d-flex justify-content-center align-items-center"},[_c('hr',{staticClass:"join-separator w-100 mx-3"}),_vm._v(" "),_c('span',{staticClass:"separator-text"},[_vm._v("or")]),_vm._v(" "),_c('hr',{staticClass:"join-separator w-100 mx-3"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }